import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { trakrefBlue } from '../../color_utils';
import { trakrefFontFamily, trakrefFontFamilyBold } from '../../utils';
import PropTypes from 'prop-types';

const AddButton = ({
    text,
    redirectLink,
    onClick,
    sx,
    disabled
}) => {
    return (
        <Button
            disabled={disabled}
            variant="contained"
            href={redirectLink}
            onClick={onClick}
            endIcon={<AddIcon />}
            size="small"
            sx={{
                ":hover": {
                    bgcolor: trakrefBlue
                },
                ":focus": {

                    outline: "none"
                },
                backgroundColor: trakrefBlue,
                fontFamily: { xs: trakrefFontFamily, lg: trakrefFontFamilyBold },
                fontSize: { xs: '0.9375rem', lg: '14px' },
                letterSpacing: { xs: '0.46px', lg: '1.2px' },
                lineHeight: { xs: '26px', lg: 'none' },
                color: '#fff',
                marginBottom: '1%',
                "&:hover": {
                    color: "white"
                },
                ...sx
            }}
        >
            {text}
        </Button>
    );
};

AddButton.propTypes = {
    text: PropTypes.string.isRequired,
    redirectLink: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};

AddButton.defaultProps = {
    redirectLink: '',
    onClick: () => { },
    disabled: false
};

export default AddButton;
